module.exports = __webpack_public_path__ + "img/川贝母.2cbaf85d.jpg";